import React from 'react';
import { Loader } from '../Loader';
import { LoaderWrapper } from './styled';

export const ViewLoader: React.FC<{}> = () => (
  <LoaderWrapper>
    <Loader message="Cargando ..." />
  </LoaderWrapper>
);
